import { PaywallScreens } from '~analytics/types';
import { PaywallAction } from '~teacher/components/PaywallDialog';
import { useImportQuizToWorkspaceDialogState } from '~teacher/components/workspaces/ImportQuizToWorkspace';
import { useWorkspacePermissionsV2 } from '~teacher/hook/workspaces';

interface UseImportQuizToWorkspaceDialogParams {
  workspaceId: string;
  featurePaywallDispatch: (value: PaywallAction) => void;
}

export function useImportQuizToWorkspaceDialog({
  workspaceId,
  featurePaywallDispatch,
}: UseImportQuizToWorkspaceDialogParams) {
  const importQuizToWorkspaceDialogState =
    useImportQuizToWorkspaceDialogState();

  const {
    permissions: { importQuizBySoc: canImportQuizBySoc },
  } = useWorkspacePermissionsV2({ workspaceId });

  const openImportQuiz = () => {
    if (canImportQuizBySoc) {
      importQuizToWorkspaceDialogState.setIsOpen(true);
    } else {
      featurePaywallDispatch({
        type: 'OPEN',
        touch: [PaywallScreens.SharedLibraryListImportQuiz],
      });
    }
  };
  return { importQuizToWorkspaceDialogState, openImportQuiz };
}
